import { CoreFieldProps, fieldTypes } from "@ucl/library";
import { FC } from "react";
import { FieldComplexV2 } from "./FieldComplexV2";
import { COMPLEX_FIELD_KEYS } from "@/constants/fieldKeys";
import "./ComplexFields.scss";
import { NonLawFirmOrganizationAccountRiskReview } from "@/types/NonLawFirmOrganizationAccountRiskReview";

export interface NonLawFirmOrganizationAccountRiskReviewComplexFieldProps
  extends fieldTypes.BaseFieldProps<NonLawFirmOrganizationAccountRiskReview> {}

export const NonLawFirmOrganizationAccountRiskReviewComplexField: FC<
  NonLawFirmOrganizationAccountRiskReviewComplexFieldProps
> = (props) => {
  return (
    <section className="complex-field-container risk-review">
      <div className="complex-field-content">
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.ACCEPTABLE_BUSINESS
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.LOCATION}
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.NSF_HISTORY}
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.YEARS_IN_INDUSTRY
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.IN_GOOD_STANDING_SECRETARY_OF_STATE
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.NEGATIVE_SOCIAL_MEDIA_CHECK
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.ADDRESS_VERIFICATION
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.BENEFICIAL_OWNER_INFORMATION_COMPLETE
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.BENEFICIAL_OWNER_1_CREDIT_SCORE
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.BENEFICIAL_OWNER_2_CREDIT_SCORE
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.BENEFICIAL_OWNER_3_CREDIT_SCORE
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
        <FieldComplexV2
          {...props}
          complexFieldKey={
            COMPLEX_FIELD_KEYS.NON_LAW_FIRM_ORGANIZATION_ACCOUNT_RISK_REVIEW.BENEFICIAL_OWNER_4_CREDIT_SCORE
          }
          complexFieldProps={{
            showClearButton: true,
          } as Partial<CoreFieldProps>}
        />
      </div>
    </section>
  );
}; 